module.exports = __webpack_public_path__ + "static/media/_blank.4aa6a5e0.png";